import {
  Building2,
  DollarSign,
  Mail,
  RefreshCw,
  ShieldCheck,
  TrendingUp,
} from 'lucide-react'
import type { ReportHubCategoryMeta } from '../types'

/**
 * Presentational hub grouping. Desktop columns (top-aligned stacks):
 * Financial | Property + Performance | Reimbursements + Communication
 */
export const REPORT_HUB_CATEGORIES: ReportHubCategoryMeta[] = [
  {
    id: 'financial-payments',
    label: 'Financial & Payments',
    shortLabel: 'Financial',
    icon: DollarSign,
    tone: 'green',
  },
  {
    id: 'property-applications',
    label: 'Property & Applications',
    shortLabel: 'Property & Applications',
    icon: Building2,
    tone: 'blue',
  },
  {
    id: 'reimbursements',
    label: 'Reimbursements',
    shortLabel: 'Reimbursements',
    icon: RefreshCw,
    tone: 'purple',
  },
  {
    id: 'performance-growth',
    label: 'Performance & Growth',
    shortLabel: 'Performance',
    icon: TrendingUp,
    tone: 'amber',
  },
  {
    id: 'communication',
    label: 'Communication',
    shortLabel: 'Communication',
    icon: Mail,
    tone: 'pink',
  },
  {
    id: 'system-audit-logs',
    label: 'System & Audit Logs',
    shortLabel: 'System & Logs',
    icon: ShieldCheck,
    tone: 'teal',
  },
]
